import {useNavigate} from 'react-router-dom';
import {
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    UncontrolledDropdown
} from 'reactstrap';
import {LogOut} from 'lucide-react';
import {useAuthStateManager} from '../../hooks/useAuthStateManager';
import {RoutePaths} from '../../RoutePaths';

/** The account menu shown once logged in. */
const UserMenu = () => {
    const {email, logout} = useAuthStateManager();
    const navigate = useNavigate();

    return (
        <UncontrolledDropdown nav inNavbar>
            <DropdownToggle nav caret>
                {email}
            </DropdownToggle>
            <DropdownMenu end>
                <DropdownItem
                    onClick={() => {
                        logout();
                        navigate(RoutePaths.home());
                    }}
                >
                    <LogOut size={14} className="me-2" /> Logout
                </DropdownItem>
            </DropdownMenu>
        </UncontrolledDropdown>
    );
};

export default UserMenu;
